import OpenAI from 'openai';

const apiKey = import.meta.env?.VITE_OPENAI_API_KEY;

if (!apiKey) {
  console.warn('OpenAI API key not found. OpenAI features will not work.');
}

/**
 * Initializes the OpenAI client with the API key from environment variables.
 * @returns {OpenAI|null} Configured OpenAI client instance or null if API key is missing.
 */
let openai = null;

try {
  if (apiKey) {
    openai = new OpenAI({
      apiKey: apiKey,
      dangerouslyAllowBrowser: true, // Required for client-side usage in React
    });
  }
} catch (error) {
  console.error('Failed to initialize OpenAI client:', error);
}

export default openai;